module.exports = __webpack_public_path__ + "static/img/cd3983401dbf31b8feaf4a4a75f277ccbb24a7e4.f67e9c6a.png";